import { ChangeEvent, FunctionComponent, useEffect, useState } from 'react'
import DaycareSelector from '@/components/DaycareSelector/daycareSelector'
import { Daycare, DaycareType } from '@/types/Daycare'
import ButtonTextIcon from '@/components/_custom/Buttons/ButtonTextIcon/ButtonTextIcon'
import { Add, Diversity2, NoMeetingRoom, Settings } from '@mui/icons-material'
import styles from './familiesHeader.module.scss'
import AddFamilyDialog from './Dialog/addFamilyDialog'
import { Role } from '@/types/Role'
import { useTranslation } from 'react-i18next'
import Tabs from '@/components/_custom/Tabs/tabs'
import Desktop from '@/modules/desktopMobile/desktop'
import ButtonIcon from '@/components/_custom/Buttons/ButtonIcon/ButtonIcon'
import { useAuth } from '@/modules/context/AuthContext'
import { NavigateFunction, useNavigate } from 'react-router-dom'

interface FamiliesHeaderProps {
    currentDaycare: Daycare
    switchTab: number
    handleTabSwitch: (e: ChangeEvent<NonNullable<unknown>>, newTab: number) => void
    refetchAllParent: () => void
    refetchAllChilds: () => void
    getAllParentsInAllDaycares: (showOnlyWithoutDaycare: boolean) => void
    loadingGetAllParentsInAllDaycares: boolean
}

const FamiliesHeader: FunctionComponent<FamiliesHeaderProps> = ({
    currentDaycare,
    switchTab,
    handleTabSwitch,
    refetchAllParent,
    refetchAllChilds,
    getAllParentsInAllDaycares,
    loadingGetAllParentsInAllDaycares
}: FamiliesHeaderProps) => {
    const { t } = useTranslation()

    const { user } = useAuth()

    const navigate: NavigateFunction = useNavigate()

    const [isAddFamilyDialogOpen, setAddFamilyDialogOpen] = useState<boolean>(false)

    const [autoLinkDaycare, setAutoLinkDaycare] = useState<string>('')
    const [autoLinkActive, setAutoLinkActive] = useState<boolean>(false)

    useEffect(() => {
        setAutoLinkDaycare(currentDaycare?.autoLink || '')
        setAutoLinkActive(!!currentDaycare?.autoLinkEnable)
    }, [currentDaycare])

    const isRpeOrLaep: boolean = currentDaycare?.type === DaycareType.rpe || currentDaycare?.type === DaycareType.laep

    const TAB_LIST: string[] = [t('childs'), t('adults')]

    return (
        <div className={styles.HeaderRow}>
            {user && user?.daycares.length > 1 && (
                <div className={styles.MultipleSections}>
                    <DaycareSelector />
                    {user?.role === Role.cald && switchTab === 1 && (
                        <div>
                            <ButtonIcon
                                icon={<Diversity2 />}
                                disabled={loadingGetAllParentsInAllDaycares}
                                onClick={() => getAllParentsInAllDaycares(false)}
                            />
                            <ButtonIcon
                                icon={<NoMeetingRoom />}
                                disabled={loadingGetAllParentsInAllDaycares}
                                onClick={() => getAllParentsInAllDaycares(true)}
                            />
                        </div>
                    )}
                </div>
            )}
            {user?.currentDaycareRights.canReadFamilies && (
                <div
                    className={`${styles.TabsContainer} ${
                        user?.daycares.length === 1 && !user?.currentDaycareRights.canWriteFamilies
                            ? styles.TabsContainerAlone
                            : user?.daycares.length === 1 && user?.currentDaycareRights.canWriteFamilies
                              ? styles.TabsContainerWithParameters
                              : styles.TabsContainerWithParametersAndDaycares
                    }`}
                >
                    <Tabs value={switchTab} onChange={handleTabSwitch} tabList={TAB_LIST} />
                </div>
            )}
            {user?.currentDaycareRights.canWriteFamilies && (
                <Desktop>
                    <div className={styles.Parameters}>
                        <ButtonTextIcon
                            type={'custom'}
                            onClick={() => setAddFamilyDialogOpen(true)}
                            customIcon={<Add />}
                            customText={isRpeOrLaep ? t('invitePublic') : t('inviteFamily')}
                        />
                        {user.currentDaycareRights.canReadParamsDaycare && (
                            <Settings
                                className={styles.Icon}
                                onClick={() => navigate(`/daycare?daycare=${currentDaycare.id}#settings`)}
                            />
                        )}
                    </div>
                    <AddFamilyDialog
                        open={isAddFamilyDialogOpen}
                        closeDialog={() => setAddFamilyDialogOpen(false)}
                        daycare={currentDaycare}
                        isRpeOrLaep={isRpeOrLaep}
                        autoLinkActive={autoLinkActive}
                        autoLinkDaycare={autoLinkDaycare}
                        refetchAllParent={refetchAllParent}
                        refetchAllChilds={refetchAllChilds}
                    />
                </Desktop>
            )}
        </div>
    )
}

export default FamiliesHeader
